import { render, staticRenderFns } from "./aiWeightPhy.vue?vue&type=template&id=3e7ded91&scoped=true&"
import script from "./aiWeightPhy.vue?vue&type=script&lang=ts&"
export * from "./aiWeightPhy.vue?vue&type=script&lang=ts&"
import style0 from "./aiWeightPhy.vue?vue&type=style&index=0&id=3e7ded91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7ded91",
  null
  
)

export default component.exports